import type { MisconceptionDefinition } from '../types'

/** REK — Context (meerstaps) specifieke misconcepties (slice 5). */
export const contextMeerstapsMisconceptions: MisconceptionDefinition[] = [
  // ── REK-CONTEXT (meerstaps) specific misconceptions ──────────────────
  {
    id: 'rek.context-wrong-order',
    label: 'Verkeerde volgorde van stappen in meerstapsprobleem',
    module: 'Basisrekenen',
    description:
      'Leerling voert de stappen in een meerstapsprobleem in de verkeerde volgorde uit (bv. korting toepassen vóór het totaal te berekenen).',
    typicalFamilies: ['REK-CONTEXT-MEERSTAPS', 'REK-CONTEXT-PLUS-MIN'],
  },
  {
    id: 'rek.context-wrong-scale',
    label: 'Verkeerde schaalfactor uit context',
    module: 'Basisrekenen',
    description:
      'Leerling kiest de verkeerde schaal- of vermenigvuldigingsfactor (bv. 3 i.p.v. 3,5; afgeronde waarde i.p.v. exacte).',
    typicalFamilies: ['REK-CONTEXT-MEERSTAPS', 'REK-CONTEXT-KEER-DEEL'],
  },
  {
    id: 'rek.rounding-overshoot',
    label: 'Te ver naar boven afgerond',
    module: 'Basisrekenen',
    description:
      'Leerling rondt af naar een eenheid groter dan nodig in een context (bv. naar 100-tal terwijl 10-tal volstaat), waardoor de schatting te hoog wordt.',
    typicalFamilies: ['REK-CONTEXT-MEERSTAPS', 'REK-SCHATTEN'],
  },
]
